/**
 * Collapsed Column Labels (vertical rotated text)
 * Reads sidebarWidth from boardLayoutStore.
 */

import { memo } from 'react';
import { getMaxRow } from '../../utils/boardHelpers';
import { useColumnYOffsets, useRowAssignments, useRowHeight, useLayoutTotalHeight, useSidebarWidth } from '../BoardLayoutContext';
import { useColumnNames } from '../../../stores/hooks';
import { popupStore } from '../../stores/popupStore';

export const ColumnLabelsCollapsed = memo(function ColumnLabelsCollapsed() {
  const columns = useColumnNames();
  const columnYOffsets = useColumnYOffsets();
  const rowAssignments = useRowAssignments();
  const rowHeight = useRowHeight();
  const totalHeight = useLayoutTotalHeight();
  const width = useSidebarWidth();

  return (
    <div style={{ position: 'relative', height: totalHeight }}>
      {columns.map((column, index) => {
        const yOffset = columnYOffsets[column] ?? 0;
        const rowCount = Math.max(1, getMaxRow(rowAssignments[column]) + 1);
        const height = rowCount * rowHeight + 8;

        return (
          <div
            key={column}
            onContextMenu={(e) => {
              e.preventDefault();
              popupStore.send({ type: 'popup.openColumnMenu', column, x: e.clientX, y: e.clientY });
            }}
            style={{
              position: 'absolute',
              top: yOffset,
              left: 0,
              width,
              height,
              borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
              backgroundColor: index % 2 !== 0 ? 'rgba(0, 0, 0, 0.02)' : 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <span
              style={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
                fontSize: 10,
                fontWeight: 600,
                color: '#64748b',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxHeight: height - 8,
              }}
              title={column}
            >
              {column}
            </span>
          </div>
        );
      })}
    </div>
  );
});
